import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  AngularDatasModule,
  FxRateService,
  LocalStorageService,
} from '@univacity/angular/datas';
import { AngularUiModule } from '@univacity/angular/ui';
import {
  CreateCurrency,
  FxRate,
  PAYMENT_CURRENCY,
  Setting,
} from '@univacity/shared/types';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';

export type CurrencyInput = Omit<
  CreateCurrency,
  'resourceType' | 'markup' | 'locale'
> & {
  flag: string;
};

@Component({
  selector: 'un-currency-nav',
  imports: [NzDropDownModule, AngularUiModule, AngularDatasModule],
  templateUrl: './currency-nav.component.html',
  styleUrls: ['./currency-nav.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencyNavComponent implements OnInit {
  @Input() currencies: CurrencyInput[] = [
    {
      flag: 'us',
      code: 'USD',
      name: $localize`US Dollar`,
      symbol: '$',
    },
    {
      flag: 'eu',
      code: 'EUR',
      name: $localize`EURO`,
      symbol: '€',
    },
    {
      flag: 'gb',
      code: 'GBP',
      name: $localize`Pounds`,
      symbol: '£',
    },
    {
      flag: 'ng',
      code: 'NGN',
      name: $localize`Naira`,
      symbol: '₦',
    },
    {
      flag: 'kn',
      code: 'KES',
      name: $localize`Kenya Sheling`,
      symbol: 'Ksh',
    },
  ];

  @Output() currencyChange = new EventEmitter<CurrencyInput>();
  selectedCurrency?: CurrencyInput;
  get _currencies() {
    return this.currencies.filter(
      (c) => c.code !== this.selectedCurrency?.code
    );
  }
  constructor(
    private fxRate: FxRateService,
    private storage: LocalStorageService
  ) {}

  ngOnInit(): void {
    const selected =
      this.storage.getItem<FxRate>(Setting.currency) || PAYMENT_CURRENCY.USD;
    const cur = this.currencies.find((c) => c.code === selected);
    cur && this.select(cur, false);
  }
  select(currency: CurrencyInput, emit = true) {
    this.selectedCurrency = currency;
    this.fxRate.update(currency.code);
    if (emit) this.currencyChange.emit(currency);
  }
}
